import * as React from 'react';
import {Query} from 'react-apollo';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    Lead as LeadFragment,
    GetLead as GetLeadQuery,
    GetLeadVariables as GetLeadQueryVariables,
} from 'nutshell-graphql-types';

import GET_LEAD from '../shared/graphql/queries/get-lead.graphql';

type ComponentProps = OwnProps & {
    lead: LeadFragment | null | undefined;
    isLoading: boolean;
    refetchLead: () => Promise<any>;
    errorMessage: string | null | undefined;
};

class GetLeadComponent extends React.PureComponent<ComponentProps> {
    componentDidMount() {
        document.addEventListener('entityWasEdited', this.props.refetchLead);

        // Leads have additional events we need to check for
        if (typeof Lead !== 'undefined' && Lead.events) {
            document.addEventListener(
                Lead.events.LeadBackboneModelDidUpdate,
                this.props.refetchLead
            );
        }
    }

    componentWillUnmount() {
        document.removeEventListener('entityWasEdited', this.props.refetchLead);

        // Leads have additional events we need to check for
        if (typeof Lead !== 'undefined' && Lead.events) {
            document.removeEventListener(
                Lead.events.LeadBackboneModelDidUpdate,
                this.props.refetchLead
            );
        }
    }

    render() {
        return this.props.children({
            isLoading: this.props.isLoading,
            lead: this.props.lead,
            errorMessage: this.props.errorMessage,
            refetchLead: this.props.refetchLead,
        });
    }
}

type OwnProps = {
    leadId?: string;
    leadNum?: number;
    onCompleted?: (
        arg1:
            | {
                  lead: LeadFragment;
              }
            | undefined
    ) => void;
    children: (arg1: {
        isLoading: boolean;
        lead: LeadFragment | null | undefined;
        errorMessage: string | null | undefined;
        refetchLead: () => Promise<any>;
    }) => React.ReactElement;
};

class GetEntityQuery extends Query<GetLeadQuery, GetLeadQueryVariables> {}

export const GetLead = (props: OwnProps) => (
    <GetEntityQuery
        query={GET_LEAD}
        variables={{id: props.leadId, number: props.leadNum}}
        // @ts-expect-error
        onCompleted={props.onCompleted}
        notifyOnNetworkStatusChange={true} // So that `onCompleted` fires on cache results
    >
        {({loading, data, refetch, error}) => {
            const lead = data && data.lead;

            return (
                <GetLeadComponent
                    {...props}
                    isLoading={loading}
                    lead={lead}
                    refetchLead={refetch}
                    // @ts-expect-error
                    errorMessage={safelyGetGraphQLErrorMessage(error)}
                >
                    {props.children}
                </GetLeadComponent>
            );
        }}
    </GetEntityQuery>
);
